import { createCrumbHandle } from '../../utilities/auth';
import withLazyLoading from '../../hoc/withLazyLoading';
import { SCADA_RULES, access } from '../../access';

const SetPointConfigurationPage = withLazyLoading(
  () => import('../../pages/setPointConfiguration'),
);

const setPointConfigurationRoute = [
  {
    path: '/set-point-configuration',
    handle: { ...createCrumbHandle('Set Point Configuration'), ...access(SCADA_RULES.author) },
    element: <SetPointConfigurationPage />,
  },
];

export default setPointConfigurationRoute;
